import React, { useCallback, useState, useMemo } from 'react';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { JoykitIcon } from '@components/JoykitIcon';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { VideoModal } from '@sections/rachel-zoe/components/VideoModal';
import { rachelZoePageData } from '@data-ts/pages/rachel-zoe';
import { VideoOverlay, PlayIconTextWrapper, TitleWrapper } from './VideoWithStaticImages.styles';

export interface VideoWithStaticImagesContentProps {
  readonly title: string;
  readonly video: string;
  readonly videoPoster: string;
}

export const VideoWithStaticImagesContent: React.FC<VideoWithStaticImagesContentProps> = ({ title, video, videoPoster }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const posterImage = useMemo(() => cloudAssetUrl(videoPoster), [videoPoster]);

  const handleWatchVideo = useCallback(() => setIsModalOpen(currentIsModalOpen => !currentIsModalOpen), []);

  return (
    <>
      <VideoOverlay />
      <PlayIconTextWrapper onClick={handleWatchVideo}>
        <Flex style={{ placeItems: 'center' }}>
          <JoykitIcon name="playCircle" color="white" size={40} />
        </Flex>
        <Flex style={{ placeItems: 'center' }}>
          <Text variant="featureCopy17" color="mono7" tagName="p">
            {rachelZoePageData.sections.curatedRegistry.watchVideo}
          </Text>
        </Flex>
      </PlayIconTextWrapper>
      <VideoModal videoUrl={video} poster={posterImage} isModalOpen={isModalOpen} handleClose={handleWatchVideo} />
      <TitleWrapper flexDirection="column" justifyContent="flex-end">
        <Text variant="hed40" color="white" tagName="h2">
          {title}
        </Text>
      </TitleWrapper>
    </>
  );
};
